import { formatInTimeZone, fromZonedTime } from 'date-fns-tz';
import { isAfter } from 'date-fns';
import { CaseFacility } from '@/api/apis/case';
import { WithOcsTimestamp } from './types';

export const getDateTimeInputValues = (facility?: CaseFacility) => {
  const current = new Date();
  const timeZone = facility?.location?.timezone ?? 'America/New_York';
  const date = formatInTimeZone(current, timeZone, 'yyyy-MM-dd');
  const time = formatInTimeZone(current, timeZone, 'HH:mm:ss');

  return { date, time, timeZone };
};

export const dateBeforeOnOCSCheck =
  <T extends WithOcsTimestamp>(dateField: keyof T, timeField: keyof T, timeZoneField: keyof T) =>
  (data: T) => {
    const pickerDateInTimezone = fromZonedTime(
      new Date(`${data[dateField]} ${data[timeField]}`),
      data[timeZoneField] as string,
    );
    const isBeforeOnOcs =
      data?.onOcsTimestamp && data[dateField] && data[timeField] && isAfter(pickerDateInTimezone, data.onOcsTimestamp);

    return isBeforeOnOcs || !data?.onOcsTimestamp;
  };
